<template>
<div class="medic-valorations" >
    <div class="reviews-container">
        <div class="row">
            <div class="col-lg-3" v-if="medic.valorations">
                <div id="review_summary">
                    <strong>{{medic.rate}}</strong>
                    <star-rating :star-size="16" :read-only="true" :show-rating="false" :rating="medic.rate" active-color="#fff" inactive-color="#1189ab" :inline="true"></star-rating>
                    <small>Basada en {{medic.valorations.length}} valoraciones</small>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="row">
                    <div class="col-9">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ this.starsbarpercent.five + '%'" :aria-valuenow="this.starsbarpercent.five" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                    <div class="col-3"><small><strong>5 estrellas</strong></small></div>
                </div>
                <!-- /row -->
                <div class="row">
                    <div class="col-9">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ this.starsbarpercent.four + '%'" :aria-valuenow="this.starsbarpercent.four" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                    <div class="col-3"><small><strong>4 estrellas</strong></small></div>
                </div>
                <!-- /row -->
                <div class="row">
                    <div class="col-9">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ this.starsbarpercent.three + '%'" :aria-valuenow="this.starsbarpercent.three" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                    <div class="col-3"><small><strong>3 estrellas</strong></small></div>
                </div>
                <!-- /row -->
                <div class="row">
                    <div class="col-9">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ this.starsbarpercent.two + '%'" :aria-valuenow="this.starsbarpercent.two" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                    <div class="col-3"><small><strong>2 estrellas</strong></small></div>
                </div>
                <!-- /row -->
                <div class="row">
                    <div class="col-9">
                        <div class="progress">
                            <div class="progress-bar" role="progressbar" :style="'width:'+ this.starsbarpercent.one + '%'" :aria-valuenow="this.starsbarpercent.one" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                    <div class="col-3"><small><strong>1 estrella</strong></small></div>
                </div>
                <!-- /row -->
            </div>
        </div>
        <!-- /row -->

        <hr class="mt-4 mb-4">

        <div class="review-box clearfix" v-for="valoration in medic.valorations" :key="valoration.id">
            <figure class="rev-thumb"><img src="https://via.placeholder.com/150x150.jpg" alt=""></figure>
            <div class="rev-content">
                
                <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="valoration.rate"></star-rating>

                <div class="rev-info">
                    {{valoration.user.name}} | {{valoration.created_at | moment('DD-MM-YYYY')}}
                </div>
                <div class="rev-text">
                    <p>
                        {{valoration.comments}}
                    </p>
                </div>
            </div>
        </div>
        <!-- End review-box -->

    </div>
</div>
</template>

<script>
import gql from 'graphql-tag'

export default {
    name: 'MedicValorations',
    props:['id'],
    data(){
        return{
            medic:{},
            starsbarcount:{
                one:0,
                two:0,
                three:0,
                four:0,
                five:0,
            },
            starsbarpercent:{
                one:0,
                two:0,
                three:0,
                four:0,
                five:0,
            }
        }
    },
    methods:{
        calcPercentages(){
            let totalVotes = this.medic.valorations.length;
            
            if(totalVotes>0){
                this.medic.valorations.forEach( (valoration)=>{
                    if( valoration.rate == 5 ){ this.starsbarcount.five ++; }
                    if( valoration.rate == 4 ){ this.starsbarcount.four ++; }
                    if( valoration.rate == 3 ){ this.starsbarcount.three ++; }
                    if( valoration.rate == 2 ){ this.starsbarcount.two ++; }
                    if( valoration.rate == 1 ){ this.starsbarcount.one ++; }
                });

                if( this.starsbarcount.five > 0 ){
                    this.starsbarpercent.five =    (this.starsbarcount.five * 100 ) / totalVotes ;
                }
                if( this.starsbarcount.four > 0 ){
                    this.starsbarpercent.four = (this.starsbarcount.four * 100 ) / totalVotes ;
                }
                if( this.starsbarcount.three > 0 ){
                    this.starsbarpercent.three = (this.starsbarcount.three * 100 ) / totalVotes ;
                }
                if( this.starsbarcount.two > 0 ){
                    this.starsbarpercent.two = (this.starsbarcount.two * 100 ) / totalVotes ;
                }
                if( this.starsbarcount.one > 0 ){
                    this.starsbarpercent.one = (this.starsbarcount.one * 100 ) / totalVotes ;
                }
            }
            


        }
    },
    apollo:{
		medic: {
			query: gql`query getMedic($id: ID) {
				medic(id: $id) {
                    id
                    rate
                    valorations{
                        rate
                        comments
                        created_at
                        user{
                            name
                        }
                    }
				}
            }`,
            //skip:true,
            variables() {
				return {
					id: this.id,
				}
            },
            result() {
                this.calcPercentages()
            },
		},
	},
}
</script>

<style scoped>

.reviews-container .progress {
    margin-bottom: 10px;
}

.reviews-container .progress-bar {
    background-color: #74d1c6;
}

#review_summary {
    text-align: center;
    background-color: #12bcec;
    color: #fff;
    padding: 20px 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
}

@media (max-width: 991px) {
    #review_summary {
        /* For less than 991px */
        margin-bottom: 15px;
    }
}

#review_summary strong {
    font-size: 3rem;
    line-height: 1;
    display: block;
}
#review_summary small {
    font-size: 10px;
    line-height: 10px;
    margin-top: 6px;
    display: block;
}


.reviews-container .review-box {
    position: relative;
    margin-bottom: 25px;
    display: flex;
    min-height: 100px;
}

@media (max-width: 767px) {
    .reviews-container .review-box {
        /* For less than 767px */
        padding-left: 0;
    }
}

.reviews-container .rev-thumb {
    width: 80px;
    height: 80px;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0px;
    margin: 0px;
    
    flex-flow: 0;
    flex-shrink: 0;
}

.reviews-container .rev-thumb img {
    width: 80px;
    height: auto;
}

@media (max-width: 767px) {
    
}

.reviews-container .rev-content {
    position: relative;
    padding: 10px 15px 0 15px;
    margin-left: 8px;
    border: 1px solid #ededed;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    flex-grow: 1;
}

.reviews-container .rev-info {
    font-size: 0.75rem;
    font-style: italic;
    color: #777;
    margin-bottom: 10px;
}
</style>
